var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "700" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.title))]),
      _c(
        "w-scroll-view",
        { style: { minHeight: "400px" }, attrs: { tag: "div" } },
        [
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input", {
                        attrs: { label: _vm.$ct("common.title") },
                        model: {
                          value: _vm.data.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "title", $$v)
                          },
                          expression: "data.title",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-select-book-year", {
                        attrs: {
                          decimals: 0,
                          label: _vm.$ct("bookyear-override-optional"),
                          "add-previous-book-year-option": "",
                          "add-selected-book-year-option": "",
                        },
                        model: {
                          value: _vm.data.bookYearOverride,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "bookYearOverride", $$v)
                          },
                          expression: "data.bookYearOverride",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-checkbox", {
                        attrs: {
                          value: !_vm.data.hideLastMonth,
                          label: _vm.$ct("show-last-month"),
                        },
                        on: {
                          input: function ($event) {
                            _vm.data.hideLastMonth = !$event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-input-number", {
                        attrs: {
                          min: 0,
                          max: 5,
                          label: _vm.$ct("to-show-extra-years"),
                          decimals: 0,
                        },
                        model: {
                          value: _vm.data.toShowAdditionalBookYears,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "toShowAdditionalBookYears", $$v)
                          },
                          expression: "data.toShowAdditionalBookYears",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("w-card-title", [_vm._v(" " + _vm._s(_vm.$ct("filters")) + ": ")]),
          _vm.browse && _vm.model
            ? _c("app-human-filter-list-edit", {
                attrs: { browse: _vm.browse, model: _vm.model },
                model: {
                  value: _vm.data.filters,
                  callback: function ($$v) {
                    _vm.$set(_vm.data, "filters", $$v)
                  },
                  expression: "data.filters",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { icon: "check" },
              on: {
                click: function ($event) {
                  return _vm.confirm()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }